import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FIELD_BORDER } from './manageEventFieldStyles';

const MapFrame = styled('iframe')({
  width: '100%',
  height: '100%',
  border: 0,
  display: 'block',
});

const DEFAULT_LAT = 37.7745;
const DEFAULT_LNG = -122.418;

const buildMapSrc = (latitude, longitude) => {
  const lat = parseFloat(latitude);
  const lng = parseFloat(longitude);

  if (Number.isFinite(lat) && Number.isFinite(lng)) {
    const pad = 0.01;
    const bbox = `${lng - pad}%2C${lat - pad}%2C${lng + pad}%2C${lat + pad}`;
    return `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat}%2C${lng}`;
  }

  const bbox = '-122.4280%2C37.7695%2C-122.4080%2C37.7795';
  return `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${DEFAULT_LAT}%2C${DEFAULT_LNG}`;
};

const LocationMapPreview = ({ compact = false, height, latitude, longitude }) => {
  const mapHeight = height ?? (compact ? 140 : 220);

  return (
    <Box
      sx={{
        width: '100%',
        height: mapHeight,
        borderRadius: '10px',
        overflow: 'hidden',
        border: `1px solid ${FIELD_BORDER}`,
        mt: 1.5,
        boxSizing: 'border-box',
      }}
    >
      <MapFrame title="Event location map" loading="lazy" src={buildMapSrc(latitude, longitude)} />
    </Box>
  );
};

export default LocationMapPreview;
